export default "__VITE_ASSET__c9ea2ea7__"